export default (entityName: string, entityId: string, pin: string): string => {
    return `${entityName}:${entityId}:${pin}`;
};
